export const currencyEn = {
  Dashboard: `Dashboard`,
  catalog: `Catalog`,
  currencies: `Currencies`,
  currency: `Currency`,
  add_currency: `Add Currency`,
  edit_currency: `Edit Currency`,
  delete_currency: `Delete Currency`,
  delete_currency_description: `Are you sure you want to delete this currency? This action cannot be undone.`,
  code: `Code`,
  name: `Name`,
  actions: `Actions`,
  search: `Search`,
  search_placeholder: `Search by code or name`,
  filter_currencies: `Filter Currencies`,
  filter_currencies_subtitle: `Narrow down the currencies list`,
  edit: `Edit`,
  delete: `Delete`,
  cancel: `Cancel`,
  add: `Add`,
  update: `Update`,
  code_required: `Code is required`,
  name_required: `Name is required`,
  no_currencies_found: `No currencies found`,
  currency_created_successfully: `Currency created successfully`,
  currency_updated_successfully: `Currency updated successfully`,
  currency_deleted_successfully: `Currency deleted successfully`,
  something_went_wrong: `Something went wrong`,
  organization_not_found: `Organization not found for the current user`,
  currency_code_required: `Currency code is required`,
  currency_name_required: `Currency name is required`,
  currency_code_duplicate: `A currency with this code already exists`,
  currency_not_found: `Currency not found`,
  not_allowed_to_update_currency: `You are not allowed to update this currency`,
  not_allowed_to_delete_currency: `You are not allowed to delete this currency`,
  currency_listing_max_100_allowed: `A maximum of 100 currencies can be listed per page`,
};
